import { baseRoute } from '../../../constants/routes';

export const SETTINGS_ROUTE = baseRoute + '/settings';

export const GET_SETTINGS = 'GET_SETTINGS';
export const GET_SETTINGS_SUCCESS = 'GET_SETTINGS_SUCCESS' ;

export const UPDATE_SETTINGS_QUESTION_ANSWERS = 'UPDATE_SETTINGS_QUESTION_ANSWERS';
export const UPDATE_SETTINGS_QUESTION_ANSWERS_SUCCESS = 'UPDATE_SETTINGS_QUESTION_ANSWERS_SUCCESS';

export const CHANGE_FEEDBACK = 'CHANGE_FEEDBACK';
export const CHANGE_FEEDBACK_SUCCESS = 'CHANGE_FEEDBACK_SUCCESS';